import React, { memo } from 'react';

const Button = memo(({ 
  children, 
  onClick, 
  disabled = false, 
  loading = false, 
  variant = 'primary', 
  size = 'medium',
  className = '',
  style = {},
  type = 'button',
  ...props 
}) => {
  const baseStyles = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    border: 'none',
    borderRadius: '6px',
    cursor: disabled || loading ? 'not-allowed' : 'pointer',
    fontWeight: '500',
    transition: 'all 0.2s ease',
    opacity: disabled || loading ? 0.6 : 1,
    ...style
  };

  const variants = {
    primary: {
      backgroundColor: '#3b82f6',
      color: 'white',
      '&:hover': {
        backgroundColor: '#2563eb'
      }
    },
    secondary: {
      backgroundColor: '#f3f4f6',
      color: '#374151',
      border: '1px solid #d1d5db',
      '&:hover': {
        backgroundColor: '#e5e7eb'
      }
    },
    danger: {
      backgroundColor: '#dc2626',
      color: 'white',
      '&:hover': {
        backgroundColor: '#b91c1c'
      }
    },
    success: {
      backgroundColor: '#059669',
      color: 'white',
      '&:hover': {
        backgroundColor: '#047857'
      }
    },
    ghost: {
      backgroundColor: 'transparent',
      color: '#6b7280',
      '&:hover': {
        backgroundColor: '#f9fafb',
        color: '#374151'
      }
    }
  };

  const sizes = {
    small: {
      padding: '4px 8px',
      fontSize: '12px',
      minHeight: '28px'
    },
    medium: {
      padding: '6px 12px',
      fontSize: '14px',
      minHeight: '36px'
    },
    large: {
      padding: '8px 16px',
      fontSize: '16px',
      minHeight: '44px'
    }
  };

  const buttonStyles = {
    ...baseStyles,
    ...variants[variant],
    ...sizes[size]
  };

  return (
    <button
      type={type}
      className={className}
      style={buttonStyles}
      onClick={onClick}
      disabled={disabled || loading}
      {...props}
    >
      {loading && (
        <svg className="animate-spin h-4 w-4" viewBox="0 0 24 24">
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
            fill="none"
          />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          />
        </svg>
      )}
      {children}
    </button>
  );
});

export default Button;

Button.displayName = 'Button';
